import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56f05237")

_pushScopeId("data-v-56f05237")
const _hoisted_1 = { class: "relative bg-cover min-h-41 sm:min-h-47 lg:min-h-48" }
const _hoisted_2 = {
  alt: "Topic",
  class: "m-6 bg-bp-complementDarker dark:bg-bp-complementDarker rounded-3xl absolute flex justify-center overflow-auto p-0.5"
}
const _hoisted_3 = { class: "text-white dark:text-gray-100 font-extrabold py-0 px-2" }
const _hoisted_4 = { class: "text-bp-dark mx-6 dark:text-gray-300 px-0 pb-0 text-left" }
const _hoisted_5 = { class: "flex justify-between rounded-3xl p-0 pt-2" }
const _hoisted_6 = { class: "font-extrabold text-xl text-bp-complementDarker  dark:text-bp line-clamp-1" }
const _hoisted_7 = { class: "text-xs dark:text-gray-400 font-semibold leading-none flex items-center my-1" }
const _hoisted_8 = { class: "mt-0  justify-between text-center py-2 px-6 pb-5" }
const _hoisted_9 = { class: "mx-auto pt-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_subscribe_edit_dialog = _resolveComponent("subscribe-edit-dialog")
  const _component_boostpack_edit_dialog = _resolveComponent("boostpack-edit-dialog")
  const _component_router_link = _resolveComponent("router-link")
  const _component_default_button = _resolveComponent("default-button")

  return (_openBlock(), _createBlock("div", {
    id: 'boostpackCard_'+_ctx.boostpackReference,
    class: ['flex-shrink-0 z-0 bg-white dark:bg-gray-900 rounded-3xl w-full md:max-w-full shadow-lg  md:w-82 lg:w-96'] + ' ' + _ctx.bpMargin+ ' ' + _ctx.cardHeight,
    style: {"min-width":"18em","max-width":"24em"}
  }, [
    _withDirectives(_createVNode("div", null, [
      _renderSlot(_ctx.$slots, "EditSubscribtionButton", {}, () => [
        _createVNode(_component_subscribe_edit_dialog, { class: "mr-1 absolute" })
      ])
    ], 512), [
      [_vShow, _ctx.enableEditSubscription === true]
    ]),
    _withDirectives(_createVNode("div", null, [
      _renderSlot(_ctx.$slots, "EditBoostpackButton", {}, () => [
        _createVNode(_component_boostpack_edit_dialog, { class: "mr-1 absolute" })
      ])
    ], 512), [
      [_vShow, _ctx.enableEditBoostpack === true]
    ]),
    _createVNode(_component_router_link, {
      to: '/detail/'+_ctx.getBoostpackDetailReference()
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("img", {
            alt: _ctx.boostpackTitleImage,
            src: _ctx.boostpackTitleImage,
            class: "rounded-t-3xl absolute object-cover object-top w-full h-full",
            loading: "lazy"
          }, null, 8, ["alt", "src"]),
          _createVNode("div", null, [
            _createVNode("div", _hoisted_2, [
              _createVNode("p", _hoisted_3, _toDisplayString(_ctx.categoryTitle), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", null, [
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.boostpackTitle), 1)
        ])
      ]),
      _createVNode("p", {
        class: "font-semibold text-xs md:text-sm w-full pl-0 h-16 sm:h-16 line-clamp-3",
        innerHTML: _ctx.boostpackDescription
      }, null, 8, ["innerHTML"]),
      _createVNode("span", _hoisted_7, "@" + _toDisplayString(_ctx.boostpackCreator), 1)
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", null, [
        _createVNode("span", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: '/detail/'+_ctx.getBoostpackDetailReference()
          }, {
            default: _withId(() => [
              _createVNode(_component_default_button, {
                "button-text": _ctx.$t('card.DefaultBoostpackCardLayout.boostpackDetail'),
                "custom-css": "center"
              }, null, 8, ["button-text"])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ], 10, ["id"]))
})